"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsGeneralMenuTopControl = void 0;
const DOM_1 = require("../../../../public/js/utils/DOM");
const Netwtorking_1 = require("../../../../public/js/utils/Netwtorking");
const LinkBuilder_1 = require("../../../../public/js/utils/LinkBuilder");
const sweetalert2_1 = require("sweetalert2");
const customFunctions_1 = require("../../../../public/js/elements/customFunctions");
const Toggles_1 = require("../../../../public/js/utils/Toggles");
const Notify_1 = require("../../../../public/js/utils/Notify");
const RequestTypes_1 = require("../../../../public/js/definitions/utils/networking/RequestTypes");
const SideNavControl_1 = require("../SideNavControl/SideNavControl");
var ControlsGeneralMenuTopControl;
(function (ControlsGeneralMenuTopControl) {
    class Config {
        static component = 'menuTop';
        static loadUnreadMessagesBackendCallback = 'loadUnreadMessages';
        static loadUnreadTicketsBackendCallback = 'loadActiveTickets';
        static loadOverdueInvoicesBackendCallback = 'loadOverdueInvoices';
        static toggleDesktopElementId = "MenuTopControl-user-toggle";
        static showMobileElementId = "MenuTopControl-mobileMenu-show";
        static hideMobileElementId = "MenuTopControl-mobileMenu-hide";
        static dropDownElementId = "MenuTopControl-user-dropdown";
        static shownClassName = "shown";
        static actualizeTriggerElementId = "MenuTopControl-user-drop-top-item-actualize";
        static actualizeCacheBackendCallback = "actualize";
        static supportPasswordTriggerElementId = "MenuTopControl-user-drop-top-item-support";
        static supportPasswordBackendCallback = "Support";
        static showSideNavTriggerElementId = "MenuTopControl-sideNav-show";
        static invoicesBlockSelector = ".MenuTopControl-items-item.invoices";
        static ticketsBlockSelector = ".MenuTopControl-items-item.tickets";
        static messagesBlockSelector = ".MenuTopControl-items-item.messages";
        static jsTranslationsElementId = "jsTranslations";
        static jsTranslationsSupportPassword = "trsSupportPassword";
        static supportPasswordModalTriggerChangeUrlDataName = "link";
    }
    class Control {
        static triggerToggleMenu() {
            this.triggerDesktopToggle();
            this.triggerMobileShow();
            this.triggerMobileHide();
            if (document.querySelector(Config.messagesBlockSelector)) {
                this.loadUnreadMessages(false);
            }
            if (document.querySelector(Config.ticketsBlockSelector)) {
                this.loadActiveTickets(false);
            }
            if (document.querySelector(Config.invoicesBlockSelector)) {
                this.loadOverdueInvoices(false);
            }
            this.triggerCacheRefresh();
            this.triggerSupportPassword();
            this.triggerMobileShowSideNav();
            this.triggerHideOnOutsideClick();
        }
        static triggerHideOnOutsideClick() {
            window.addEventListener('click', (evt) => {
                if (!this.checkMenuOpened()) {
                    return;
                }
                const clickedInside = DOM_1.DOM.Parser.parentContainsTheClass('MenuTopControl-user-dropdown', evt.target);
                if (clickedInside) {
                    return;
                }
                this.doDesktopToggle();
            });
        }
        static checkMenuOpened() {
            return DOM_1.DOM.Parser.getHtmlElement(Config.dropDownElementId).classList.contains(Config.shownClassName);
        }
        static triggerCacheRefresh() {
            DOM_1.DOM.Parser.getHtmlElement(Config.actualizeTriggerElementId).addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                const jsTranslations = DOM_1.DOM.Parser.getHtmlElement("jsTranslations");
                const modalTitle = DOM_1.DOM.Parser.getDataByNameFromElement("trsSweetalertCacheTitle", jsTranslations);
                const modalText = DOM_1.DOM.Parser.getDataByNameFromElement("trsSweetalertCacheText", jsTranslations);
                const modalYes = DOM_1.DOM.Parser.getDataByNameFromElement("trsSweetalertYes", jsTranslations);
                const modalNo = DOM_1.DOM.Parser.getDataByNameFromElement("trsSweetalertNo", jsTranslations);
                DOM_1.DOM.Parser.getHtmlElement(Config.dropDownElementId).classList.remove(Config.shownClassName);
                sweetalert2_1.default.fire({
                    title: modalTitle,
                    html: modalText,
                    imageUrl: '/resources/images/2023/authInfographic.avif',
                    buttonsStyling: false,
                    confirmButtonText: modalYes,
                    cancelButtonText: modalNo,
                    showCancelButton: true
                })
                    .then((result) => {
                    if (result.value) {
                        void Netwtorking_1.Networking.NetworkingController.createRequest({
                            type: RequestTypes_1.RequestTypes.GET,
                            successCallback: () => {
                                setTimeout(() => {
                                    document.location.reload();
                                }, 1000);
                            },
                            url: LinkBuilder_1.LinkBuilder.LinkBuilderController.composeLink({
                                component: Config.component,
                                method: Config.actualizeCacheBackendCallback,
                                parameters: []
                            }),
                        });
                    }
                });
            });
        }
        static triggerSupportPassword() {
            if (!document.getElementById(Config.supportPasswordTriggerElementId)) {
                return;
            }
            const trigger = DOM_1.DOM.Parser.getHtmlElement(Config.supportPasswordTriggerElementId);
            trigger.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                DOM_1.DOM.Parser.getHtmlElement(Config.dropDownElementId).classList.remove(Config.shownClassName);
                void Netwtorking_1.Networking.NetworkingController.createRequest({
                    type: RequestTypes_1.RequestTypes.GET,
                    dontProcessPayload: true,
                    url: LinkBuilder_1.LinkBuilder.LinkBuilderController.composeLink({
                        component: Config.component, method: Config.supportPasswordBackendCallback, parameters: [],
                    }),
                    successCallback: (result) => {
                        const notify = Notify_1.Notify.Handler.getMessageFromPayload(result);
                        const pass = notify?.message ?? null;
                        const transElem = DOM_1.DOM.Parser.getHtmlElement(Config.jsTranslationsElementId);
                        const msgCopy = DOM_1.DOM.Parser.getDataByNameFromElement('trsSweetalertSupportpasswordCopy', transElem);
                        const msgCopied = DOM_1.DOM.Parser.getDataByNameFromElement('trsSweetalertSupportpasswordCopied', transElem);
                        const changePassText = DOM_1.DOM.Parser.getDataByNameFromElement('trsSweetalertSupportpasswordChangeText', transElem);
                        const changePassUrl = DOM_1.DOM.Parser.getDataByNameFromElement(Config.supportPasswordModalTriggerChangeUrlDataName, trigger);
                        const emptyHint = DOM_1.DOM.Parser.getDataByNameFromElement('trsSweetalertSupportpasswordEmptyHint', transElem);
                        const errorHint = DOM_1.DOM.Parser.getDataByNameFromElement('trsSweetalertSupportpasswordErrorHint', transElem);
                        const supportPasswordTitle = DOM_1.DOM.Parser.getDataByNameFromElement(Config.jsTranslationsSupportPassword, transElem);
                        let dialogHTML;
                        if (notify === null || notify.type === "error") {
                            dialogHTML = `\
                                <div class="supportPassBox error">\
                                    <div class="supportPassBox-box box"></div>\
                                    <div class="supportPassBox-hint hint">${errorHint}</div>\
                                </div>`;
                        }
                        else if (notify?.type === "info") {
                            dialogHTML = `\
                                <div class="supportPassBox empty">\
                                    <div class="supportPassBox-box box">${pass}</div>\
                                    <div class="supportPassBox-hint hint">${emptyHint}</div>\
                                </div>`;
                        }
                        else {
                            dialogHTML = `\
                                <div class="supportPassBox">\
                                    <div class="supportPassBox-box box">${pass}</div>\
                                    <div class="swal2-buttons">\
                                        <button class="btn btn-blue" id="btn-copytoclipboard" data-pass="${pass}">${msgCopy}</button>\
                                        <a class="btn btn-green" href="${changePassUrl}">${changePassText}</a>\
                                    </div>
                                </div>`;
                        }
                        void sweetalert2_1.default.fire({
                            imageUrl: '/resources/images/2023/authInfographic.avif',
                            title: supportPasswordTitle,
                            html: dialogHTML,
                            showCloseButton: true,
                            padding: '2.25em',
                            buttonsStyling: false,
                            showCancelButton: false,
                            showConfirmButton: false,
                            didOpen: function () {
                                if (notify !== null && notify.type === "success" && pass !== null) {
                                    const copyButton = DOM_1.DOM.Parser.getHtmlElement('btn-copytoclipboard');
                                    copyButton.addEventListener('click', () => {
                                        customFunctions_1.CustomFunctions.controlFunctions.copyToClipBoard(pass);
                                        Notify_1.Notify.Handler.processMessages([{ message: msgCopied, type: "success", closeModal: false, uniqKeys: null, eventId: null }]);
                                    });
                                }
                            }
                        });
                    },
                });
            });
        }
        static loadUnreadMessages(fresh) {
            if (!Toggles_1.Toggles.Handler.toggleAvailable('MENU_COUNTS')) {
                return;
            }
            void Netwtorking_1.Networking.NetworkingController.createRequest({
                type: RequestTypes_1.RequestTypes.POST,
                data: { fresh: fresh },
                url: LinkBuilder_1.LinkBuilder.LinkBuilderController.composeLink({
                    component: Config.component,
                    method: Config.loadUnreadMessagesBackendCallback,
                    parameters: []
                }),
            });
        }
        static loadOverdueInvoices(fresh) {
            if (!Toggles_1.Toggles.Handler.toggleAvailable('MENU_COUNTS')) {
                return;
            }
            void Netwtorking_1.Networking.NetworkingController.createRequest({
                type: RequestTypes_1.RequestTypes.POST,
                data: { fresh: fresh },
                url: LinkBuilder_1.LinkBuilder.LinkBuilderController.composeLink({
                    component: Config.component,
                    method: Config.loadOverdueInvoicesBackendCallback,
                    parameters: []
                }),
            });
        }
        static loadActiveTickets(fresh) {
            if (!Toggles_1.Toggles.Handler.toggleAvailable('MENU_COUNTS')) {
                return;
            }
            void Netwtorking_1.Networking.NetworkingController.createRequest({
                type: RequestTypes_1.RequestTypes.POST,
                data: { fresh: fresh },
                url: LinkBuilder_1.LinkBuilder.LinkBuilderController.composeLink({
                    component: Config.component,
                    method: Config.loadUnreadTicketsBackendCallback,
                    parameters: []
                }),
            });
        }
        static triggerDesktopToggle() {
            const trigger = DOM_1.DOM.Parser.getHtmlElement(Config.toggleDesktopElementId);
            trigger.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                this.doDesktopToggle();
            });
        }
        static doDesktopToggle() {
            const trigger = DOM_1.DOM.Parser.getHtmlElement(Config.toggleDesktopElementId);
            trigger.classList.toggle(Config.shownClassName);
            DOM_1.DOM.Parser.getHtmlElement(Config.dropDownElementId).classList.toggle(Config.shownClassName);
        }
        static triggerMobileShow() {
            const trigger = DOM_1.DOM.Parser.getHtmlElement(Config.showMobileElementId);
            trigger.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                trigger.classList.add(Config.shownClassName);
                DOM_1.DOM.Parser.getHtmlElement(Config.dropDownElementId).classList.add(Config.shownClassName);
            });
        }
        static triggerMobileHide() {
            const trigger = DOM_1.DOM.Parser.getHtmlElement(Config.hideMobileElementId);
            trigger.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                trigger.classList.remove(Config.shownClassName);
                DOM_1.DOM.Parser.getHtmlElement(Config.dropDownElementId).classList.remove(Config.shownClassName);
            });
        }
        static triggerMobileShowSideNav() {
            const trigger = DOM_1.DOM.Parser.getHtmlElement(Config.showSideNavTriggerElementId);
            trigger.addEventListener('click', (event) => {
                event.stopPropagation();
                event.preventDefault();
                SideNavControl_1.ControlsGeneralSideNavControl.Control.actionShowMenu();
            });
        }
    }
    ControlsGeneralMenuTopControl.Control = Control;
})(ControlsGeneralMenuTopControl || (exports.ControlsGeneralMenuTopControl = ControlsGeneralMenuTopControl = {}));
